import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [mockToken, setMockToken] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/password/forgot', { email });
      setSubmitted(true);
      if (res.data.mock_token_for_beta) setMockToken(res.data.mock_token_for_beta);
      toast.success('If that email exists, a reset link has been sent');
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900 mb-6"><ArrowLeft className="w-3 h-3" /> Back to sign in</Link>
        <div className="bg-white border border-gray-200 rounded-lg p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-8 h-8 bg-[#0055FF] flex items-center justify-center rounded"><Shield className="w-5 h-5 text-white" /></div>
            <span className="font-heading text-lg font-semibold">LeadXchange</span>
          </div>
          <h1 className="font-heading text-2xl font-semibold text-gray-900 mb-2">Reset your password</h1>
          <p className="text-sm text-gray-600 mb-6">Enter your email address and we'll send you a link to reset your password.</p>
          {!submitted ? (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Email</Label>
                <Input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#0055FF] hover:bg-[#0044CC] text-white" data-testid="forgot-submit-btn">
                {loading ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          ) : (
            <div className="space-y-4">
              <div className="p-4 bg-green-50 border border-green-200 rounded text-sm text-green-800">
                Check your inbox for a reset link. It expires in 1 hour.
              </div>
              {mockToken && (
                <div className="p-3 bg-amber-50 border border-amber-200 rounded text-xs">
                  <div className="font-semibold text-amber-900 mb-1">Beta mode (no email provider configured)</div>
                  <Link to={`/reset-password/${mockToken}`} className="text-[#0055FF] underline font-mono break-all" data-testid="mock-reset-link">
                    Click here to reset
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
